import { on, throttle } from './modules/_fn';

(function () {
	// const $filterEl = $('.js-filter-options');
	// const $checkallEls = $('.js-checkall');
	// const $resetFilterBtn = $('.js-filter-reset');

	// $checkallEls.each(function(index, item) {
	// 	$(item).on('change', function() {
	// 		const flag = $(this).prop('checked');
	// 		inputProp($(this).parents('.dropdown-pane').find('.checkbox-content_input'), flag);
	// 	});
	// });

	// function inputProp(els, flag) {
	// 	els.each(function(index, item) {
	// 		$(this).prop('checked', flag);
	// 	});
	// }

	// // remove
	// $(document).on('click', '.js-remove-option', function() {
	// 	$(this).parents('.tags-item').remove();
	// });

	$(document).on('click', '.js-open-fixed-checked', function() {
		let ww = window.innerWidth;
		const $el = $('.fixed-checked_swiper');

		if (ww < 640) {
			if ($el.hasClass('is-open')) {
				$el.removeClass('is-open');
				$(this).text('展開清單');
			} else {
				$el.addClass('is-open');
				$(this).text('收起清單');
			}
		}
	});

	// ---------------------------------------------------------------
	// Swiper

	// breakpoint where swiper will be destroyed
	// and switches to a dual-column layout
	const breakpoint = window.matchMedia('(max-width:39.9375rem)');

	// keep track of swiper instances to destroy later
	let fixedSwiper;

	const breakpointChecker = function () {
		// if larger viewport and multi-row layout needed
		if (breakpoint.matches) {
			// clean up old instances and inline styles when available
			if (fixedSwiper !== undefined) fixedSwiper.destroy(true, true);

			// or/and do nothing
			return;

			// else if a small viewport and single column layout needed
		} else {
			// fire small viewport version of swiper
			return enableSwiper();
		}
	};

	const enableSwiper = function () {
		const swiperTarget = '.fixed-checked_swiper';
		// if (typeof Swiper === 'undefined') return false;

		fixedSwiper = new Swiper(swiperTarget + ' .swiper-container', {
			speed: 1000,
			lazy: {
				loadPrevNext: true,
				loadPrevNextAmount: 2
			},
			slidesPerView: 'auto',
			spaceBetween: 20,
			speed: 300,
			watchOverflow: true,
			navigation: {
				nextEl: swiperTarget + ' .swiper-button-next',
				prevEl: swiperTarget + ' .swiper-button-prev'
			},
			breakpoints: {
				1440: {
					spaceBetween: 40,
				},
			},
		});
	};

	// keep an eye on viewport size changes
	on(breakpoint, 'load', breakpointChecker);
	on(breakpoint, 'change', breakpointChecker);
	// breakpoint.addEventListener('load', breakpointChecker);s
	// breakpoint.addEventListener('change', breakpointChecker);

	// kickstart
	breakpointChecker();

	// Remove Slide
	// $(document).on('click', '.js-remove-selected', function() {
	// 	$(this).parents('.fixed-checked_item').remove();
	// 	checkFixedSelect();
	// });

	// function checkFixedSelect() {
	// 	if ($('body').hasClass('has-fixed-checked')) {
	// 		if ($('.fixed-checked_item').length) {
	// 			$('#ft').css('padding-bottom', $('.fixed-checked-product').outerHeight());
	// 		} else {
	// 			$('#ft').css('padding-bottom', 0)
	// 		}

	// 		fixedSwiper.update();
	// 	}
	// }

	// on(window, 'load', checkFixedSelect);
	// on(window, 'resize', throttle(checkFixedSelect, 50, 100));

	window.updateFixedSwiper = fixedSwiper;
})();
